import { RefObject, useLayoutEffect } from "react";
import { resolveTextQuoteAnchor } from "@/zapi-frontend/shared/lib/textQuoteAnchor";
import { TComment } from "../model/types/types";
import { useCommentAnchorsStore } from "../model/store/commentAnchorsStore";
import { setCommentHighlights } from "./commentHighlights";

// Locates every anchored comment in the rendered chapter and paints it. Re-run whenever the
// comments or the rendered content change, since a re-render invalidates the old ranges.
export function useCommentHighlights(
  containerRef: RefObject<HTMLElement | null>,
  comments: TComment[],
  contentKey: string
) {
  const setEntries = useCommentAnchorsStore((s) => s.setEntries);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const entries = comments.flatMap((comment) => {
      if (!comment.anchor) return [];
      const range = resolveTextQuoteAnchor(container, comment.anchor);
      return range ? [{ commentId: comment.id, range, text: comment.anchor.quote }] : [];
    });
    setCommentHighlights(entries.map((entry) => entry.range));
    setEntries(entries);
    return () => {
      setCommentHighlights([]);
      setEntries([]);
    };
  }, [containerRef, comments, contentKey, setEntries]);
}
